import { Component, OnInit, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService, LoadingService } from 'ngx-kuv-tools';
import { ConfigService } from 'src/app/utils/config/config.service';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { ModalDeleteComponent } from 'src/app/utils/modal-delete/modal-delete.component';
import { SesionService } from 'src/app/utils/sesion/sesion.service';
import { CompraCreateComponent } from '../compra-create/compra-create.component';
import { CompraUpdateComponent } from '../compra-update/compra-update.component';
import { CompraViewComponent } from '../compra-view/compra-view.component';
import { CompraService } from '../compra.service';

@Component({
  selector: 'app-compra-index',
  templateUrl: './compra-index.component.html',
  styleUrls: ['./compra-index.component.scss']
})
export class CompraIndexComponent implements OnInit {

  filtros = [
    {
      label: 'Desde',
      column: 'fecha',
      op: 'gte',
      type: 'date'
    },
    {
      label: 'Hasta',
      column: 'fecha',
      op: 'lte',
      type: 'date'
    },
    {
      label: 'Monto',
      column: 'monto',
      op: 'substring',
      type: 'number'
    },
    {
      label: 'Estado',
      column: 'estado',
      op: 'eq',
      type: 'select',
      options: [
        {
          label: "Anulada",
          value: -1
        },
        {
          label: "Registrada",
          value: 1
        },
        {
          label: "Facturada sin pagar",
          value: 2
        },
        {
          label: "Pagada sin facturar",
          value: 3
        },
        {
          label: "Completada",
          value: 4
        }
      ]
    }
  ]

  constructor(
    public config: ConfigService,
    public formatter: FormatterService,
    private loading: LoadingService,
    private alerts: AlertService,
    private modalService: NgbModal,
    public sesion: SesionService,
    public service: CompraService
  ) { }
  columnas: any[] = [
    {
      label: "Fecha",
      attribute: "fecha",
      width: 1,
      responsive: ['XS', 'SM', 'MD'],
      value: (el: any) =>{
        return this.formatter.dateFormat(el.fecha)
      }
    },
    {
      label: 'Productos',
      attribute: 'productos',
      width: 2,
      responsive: ['SM', 'MD'],
      value: (element: any) => {
        return element.lineas.map((p: any) => p.productos.nombre).join(', ')
      }
    },
    {
      label: "Monto",
      attribute: "monto",
      width: 1,
      responsive: ['XS', 'SM', 'MD'],
      value: (element: any) => {
        return '$ ' + this.formatter.numberFormat(element.monto, 0, 0, '0')
      },
    },
    {
      label: 'Estado',
      attribute: 'estado',
      width: 1,
      responsive: ['MD'],
      value: (element: any) => {
        return (element.estado == -1) ? 'Anulada' : (element.estado == 1) ? 'Registrada' : (element.estado == 2) ? 'Facturada sin pagar' : (element.estado == 3) ? 'Pagada sin facturar' : 'Completada'
      }
    }
  ]
  acciones: any[] = [
    {
      label: 'Detalle',
      icon: 'eye',
      action: (element: any, index: number) => {
        this.view(element);
      }
    },
    {
      label: 'Editar',
      icon: 'pen',
      action: (element: any, index: number) => {
        this.update(element);
      }
    },
    {
      label: 'Eliminar',
      icon: 'trash',
      action: (element: any, index: number) => {
        this.delete(element);
      }
    }

  ]

  reloadEmitter: EventEmitter<string> = new EventEmitter();
  ngOnInit(): void {
  }

  view(element: any) {
    this.loading.show()
    this.service.view(element.id).subscribe({
      next: (res) => {
        this.loading.hide();
        let modalRef = this.modalService.open(CompraViewComponent, { size: 'lg', scrollable: true, backdrop: 'static' });
        modalRef.componentInstance.element = res;
        modalRef.result.then((result: any) => {
          this.reloadEmitter.emit('true');
        }, (reason: any) => { });
      }, error: (err) => {
        this.loading.hide();
        if (err.error) this.formatter.showErrorAlerts(err.error);
      }
    });
  }

  update(element: any) {
    this.loading.show()
    this.service.view(element.id).subscribe({
      next: (res) => {
        this.loading.hide();
        let modalRef = this.modalService.open(CompraUpdateComponent, { size: 'lg', scrollable: true, backdrop: 'static' });
        modalRef.componentInstance.element = res;
        modalRef.result.then((result: any) => {
          this.reloadEmitter.emit('true');
        }, (reason: any) => { });
      }, error: (err) => {
        this.loading.hide();
        if (err.error) this.formatter.showErrorAlerts(err.error);
      }
    });
  }

  delete(element: any) {
    let modalRef = this.modalService.open(ModalDeleteComponent, { size: 'lg', scrollable: true, backdrop: 'static' });
    modalRef.componentInstance.texto = `¿Está seguro de que desea eliminar la Compra de  ${this.formatter.dateFormat( element.fecha)} con Monto de ${this.formatter.numberFormat( element.monto)} ?`;
    modalRef.componentInstance.textoAceptar = 'Eliminar';
    modalRef.result.then((result: any) => {

      this.loading.show()
      this.service.delete(element.id,).subscribe((res) => {
        this.loading.hide();
        this.reloadEmitter.emit('true');
        this.alerts.addAlert('La compra se eliminó con éxito.', 'success');
      }, err => {
        this.loading.hide();
        if (err.error) this.formatter.showErrorAlerts(err.error);
      });
    }, (reason: any) => { });
  }
  agregar() {
    this.modalService.open(CompraCreateComponent, { size: 'lg', scrollable: true, backdrop: 'static' }).result.then((result: any) => {
      this.reloadEmitter.emit('true');
    }, (reason: any) => { });
  }

}
